// Library Methods
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

// Components
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Circle from "src/assets/shapes/Circle/Circle";
import Square from "src/assets/shapes/Square/Square";

// Types
import { ChartSpotType } from "src/services/exams/types";

type VFScreeningChartLegendType = {
  vfScreeningSpots: Array<ChartSpotType>;
};

const VFScreeningChartLegend = ({
  vfScreeningSpots,
}: VFScreeningChartLegendType) => {
  const { t } = useTranslation();

  const seenSpots = useMemo(
    () => vfScreeningSpots?.filter((point) => point?.seen),
    [vfScreeningSpots]
  );

  return (
    <div>
      <Box display="flex" alignItems="center" gap="8px">
        <Circle />
        <Typography fontSize="14px">
          <span style={{ fontWeight: 600 }}>{t("Seen")}:</span>{" "}
          {seenSpots?.length}/{vfScreeningSpots?.length}
        </Typography>
      </Box>
      <Box display="flex" alignItems="center" gap="8px">
        <Square />
        <Typography fontSize="14px">
          <span style={{ fontWeight: 600 }}>{t("Not Seen")}:</span>{" "}
          {vfScreeningSpots?.length - seenSpots?.length}/
          {vfScreeningSpots?.length}
        </Typography>
      </Box>
    </div>
  );
};

export default VFScreeningChartLegend;
